import React from 'react';
import classNames from 'classnames';
import { type NormalizedCategory } from '@wix/communities-blog-client-common';

import withFontClassName from '../../../common/hoc/with-font-class-name';
import styles from './legacy-category-header.scss';

type Props = {
  category: Pick<NormalizedCategory, 'menuLabel' | 'description'>;
  titleFontClassName?: string;
  contentFontClassName?: string;
};

const LegacyCategoryHeader = ({ category, titleFontClassName, contentFontClassName }: Props) => (
  <div
    className={classNames(styles.container, titleFontClassName, 'blog-card-background-color')}
    data-hook="legacy-category-header"
  >
    <h1 className={classNames(styles.title, 'blog-text-color')}>{category.menuLabel}</h1>
    <div className={classNames(styles.description, contentFontClassName)}>
      <span className={classNames(styles.descriptionText, 'blog-text-color')}>
        {category.description}
      </span>
    </div>
  </div>
);

export default withFontClassName(LegacyCategoryHeader);
